module.exports = require("dialog-api/lib/messenger");


//////////////////
// WEBPACK FOOTER
// external "dialog-api/lib/messenger"
// module id = 5
// module chunks = 0